export default {
	default: "admin",

	routes: {
		admin: {
			routes: [
				{title: "ארגונים", name: "organization-page"},
				{title: "מרכזים", name: "companies-page", icon: "fas fa-user-circle"},
				{title: "משתמשים", name: "users-page", icon: "fas fa-users"},
				{title: "סוגי משחק", name: "game-type-page", icon: "fas fa-gamepad"},
				// {title: "מאגר שאלות", name: "questions-page", icon: "fas fa-question"},
				// {title: "משחקים", name: "games-page", icon: "fas fa-gamepad"},
			]
		},
		client: {
			routes: [
				{title: "מרכזים", name: "companies-page", icon: "fas fa-user-circle"},
				{title: "משתמשים", name: "users-page", icon: "fas fa-users"},
				{title: "מאגר שאלות", name: "questions-page", icon: "fas fa-question"},
				{title: "משחקים", name: "games-page", icon: "fas fa-gamepad"},
				{title: "המשחקים החמים", name: "hot-games-page", icon: "fas fa-gamepad"},
				{title: "היסטוריית משחקים", name: "game-log-page", icon: "fas fa-history"},
				{title: "עדכונים", name: "updates-page", icon: "fas fa-history"}
			]
		},
		simple: {
			routes: [
				{title: "מאגר שאלות", name: "questions-page", icon: "fas fa-question"},
				{title: "משחקים", name: "games-page", icon: "fas fa-gamepad"},
				{title: "המשחקים החמים", name: "hot-games-page", icon: "fas fa-gamepad"}
			]
		}
	}
};
